var path = 'components/acls/tooltips/networksNames.html';
var html = "<div style=max-width:550px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden ng-repeat=\"network in acl.networks | orderBy\"> <span ng-bind=network.name></span> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;